export interface CategoryItem {
  name: string;
  image: string;
  link: string;
}

export interface BannerSlide {
  title: string;
  subtitle: string;
  image: string;
  link: string;
}

export interface SubBanner {
  image: string;
  link: string;
}

export interface JourneyItem {
  name: string;
  image: string;
  link: string;
}

export interface ViewedItem {
  name: string;
  image: string;
  link: string;
}

export interface ProductCard {
  id: string;
  name: string;
  brand: string;
  image: string;
  rating: number;
  reviewsCount: number;
  price: string;
  oldPrice?: string;
  discount?: string;
  isDeal?: boolean;
}

export interface CategoryBlock {
  title: string;
  link: string;
  brands: { name: string; logo: string; link: string }[];
  subCategories: { name: string; image: string; link: string; bgColor: string }[];
  products: ProductCard[];
}

export const categoriesList: CategoryItem[] = [
  {
    name: "Security Systems",
    image: "https://cdn.moglix.com/cms/flyout/Images_2023-12-11_12-17-25_agriculture-farming-equipment.jpg",
    link: "/security-systems"
  },
  {
    name: "IT & Networking",
    image: "https://cdn.moglix.com/cms/flyout/Images_2023-12-07_14-51-07_office-stationery-supplies.jpg",
    link: "/it-networking"
  },
  {
    name: "Lighting Solutions",
    image: "https://cdn.moglix.com/cms/flyout/Images_2023-12-07_15-16-50_electrical-tools-equipment.jpg",
    link: "/lighting-solutions"
  },
  {
    name: "Home Automation",
    image: "https://cdn.moglix.com/cms/flyout/Images_2023-12-12_14-44-33_1%205.jpg",
    link: "/home-automation"
  },
  {
    name: "Audio & Video",
    image: "https://cdn.moglix.com/cms/flyout/Images_2023-12-12_09-58-45_automotive-supplies.jpg",
    link: "/audio-video"
  },
  {
    name: "Electricals",
    image: "https://cdn.moglix.com/cms/flyout/Images_2023-12-07_14-51-07_office-stationery-supplies.jpg",
    link: "/electricals"
  },
  {
    name: "Computers & Accessories",
    image: "https://cdn.moglix.com/cms/flyout/Images_2023-12-07_15-16-50_electrical-tools-equipment.jpg",
    link: "/computers-accessories"
  },
  {
    name: "Office Supplies",
    image: "https://cdn.moglix.com/cms/flyout/Images_2023-12-11_12-17-25_agriculture-farming-equipment.jpg",
    link: "/office-supplies"
  },
  {
    name: "Safety Products",
    image: "https://cdn.moglix.com/cms/flyout/Images_2023-12-08_09-51-46_tools.webp",
    link: "/safety-products"
  },
  {
    name: "Services & Support",
    image: "https://cdn.moglix.com/cms/flyout/Images_2023-12-12_09-58-45_automotive-supplies.jpg",
    link: "/services-support"
  }
];

export const bannerSlides: BannerSlide[] = [
  {
    title: "SUMMER SALE",
    subtitle: "Upto 70% OFF",
    image: "https://cdn.moglix.com/cms/flyout/Image_2026-05-03_13:55:25.084_Platinum-desktop.png",
    link: "/store/summer-sale"
  },
  {
    title: "FAB",
    subtitle: "Lowest Prices",
    image: "https://cdn.moglix.com/cms/flyout/Image_2026-05-07_15:37:02.534_Fab-New-theme-banner.png",
    link: "/brands/fab"
  },
  {
    title: "FREEMANS",
    subtitle: "Upto 50% OFF",
    image: "https://cdn.moglix.com/cms/flyout/Image_2026-05-04_12:24:56.382_Freeman-platinum2.png",
    link: "/brands/freemans"
  },
  {
    title: "HILLGROVE",
    subtitle: "Upto 70% OFF",
    image: "https://cdn.moglix.com/cms/flyout/Image_2026-05-07_15:37:01.512_Hillgrove-Platinum-Desktop9.png",
    link: "/brands/Hillgrove"
  },
  {
    title: "LONGWAY",
    subtitle: "Upto 50% OFF",
    image: "https://cdn.moglix.com/cms/flyout/Image_2026-05-07_15:37:02.762_LongwayPlatinumDesktopBankoffer.png",
    link: "/brands/longway"
  }
];

export const subBanners: SubBanner[] = [
  {
    image: "https://cdn.moglix.com/cms/flyout/Image_2026-05-07_11:10:47.445_Gold-Banner-ingco.png",
    link: "/brands/ingco"
  },
  {
    image: "https://cdn.moglix.com/cms/flyout/Image_2026-05-07_11:10:47.999_Vinspire-gold-banner.gif",
    link: "/brands/vinspire"
  },
  {
    image: "https://cdn.moglix.com/cms/flyout/Image_2026-04-27_15:56:17.797_CELLBELLGoldbanner1stdesktop2xgif.gif",
    link: "/brands/cellbell"
  },
  {
    image: "https://cdn.moglix.com/cms/flyout/Image_2026-05-07_11:10:48.221_ActivaGoldDesktop1st.png",
    link: "/brands/activa"
  }
];

export const journeyItems: JourneyItem[] = [
  { name: "CP CP", image: "https://cdn.moglix.com/assets/img/home_card.webp", link: "/shop" },
  { name: "Biometric", image: "https://cdn.moglix.com/assets/img/home_card.webp", link: "/shop" },
  { name: "Multi Strand Wire", image: "https://cdn.moglix.com/assets/img/home_card.webp", link: "/shop" },
  { name: "Pedestal Fan", image: "https://cdn.moglix.com/assets/img/home_card.webp", link: "/shop" }
];

export const viewedItems: ViewedItem[] = [
  { name: "CP CP", image: "https://cdn.moglix.com/assets/img/home_card.webp", link: "/shop" },
  { name: "Biometric", image: "https://cdn.moglix.com/assets/img/home_card.webp", link: "/shop" },
  { name: "Multi Strand Wire", image: "https://cdn.moglix.com/assets/img/home_card.webp", link: "/shop" },
  { name: "Pedestal Fan", image: "https://cdn.moglix.com/assets/img/home_card.webp", link: "/shop" },
  { name: "Smart Lock", image: "https://cdn.moglix.com/assets/img/home_card.webp", link: "/shop" },
  { name: "Switch Board", image: "https://cdn.moglix.com/assets/img/home_card.webp", link: "/shop" }
];

export const recentViewProducts: ProductCard[] = [
  {
    id: "rv_p1",
    name: "CP PLUS CP-Z32G PAN/Tilt Wi-Fi CCTV camera",
    brand: "CP PLUS",
    image: "https://cdn.moglix.com/assets/img/home_card.webp",
    rating: 5.0,
    reviewsCount: 5,
    price: "₹5,700",
    oldPrice: "₹8,999",
    discount: "36% OFF",
    isDeal: true
  },
  {
    id: "rv_p2",
    name: "CP PLUS 4MP Quad HD Wi-Fi CCTV Camera for Outdoor",
    brand: "CP PLUS",
    image: "https://cdn.moglix.com/assets/img/home_card.webp",
    rating: 5.0,
    reviewsCount: 5,
    price: "₹3,700",
    oldPrice: "₹5,999",
    discount: "38% OFF",
    isDeal: true
  },
  {
    id: "rv_p3",
    name: "CP PLUS Intelligent Home PT Camera with Cloud Remote.....",
    brand: "CP PLUS",
    image: "https://cdn.moglix.com/assets/img/home_card.webp",
    rating: 5.0,
    reviewsCount: 5,
    price: "₹5,700",
    oldPrice: "₹8,999",
    discount: "36% OFF",
    isDeal: true
  },
  {
    id: "rv_p4",
    name: "CP PLUS CP-Z32G PAN/Tilt Wi-Fi CCTV camera",
    brand: "CP PLUS",
    image: "https://cdn.moglix.com/assets/img/home_card.webp",
    rating: 5.0,
    reviewsCount: 5,
    price: "₹5,700",
    oldPrice: "₹8,999",
    discount: "36% OFF",
    isDeal: true
  },
  {
    id: "rv_p5",
    name: "CP PLUS CP-Z32G PAN/Tilt Wi-Fi CCTV camera",
    brand: "CP PLUS",
    image: "https://cdn.moglix.com/assets/img/home_card.webp",
    rating: 5.0,
    reviewsCount: 5,
    price: "₹5,700",
    oldPrice: "₹8,999",
    discount: "36% OFF",
    isDeal: true
  }
];

export const bestsellerProducts: ProductCard[] = [
  {
    id: "bs_p1",
    name: "CP PLUS CP-Z32G PAN/Tilt Wi-Fi CCTV camera",
    brand: "CP PLUS",
    image: "https://cdn.moglix.com/assets/img/home_card.webp",
    rating: 5.0,
    reviewsCount: 5,
    price: "₹5,700",
    oldPrice: "₹8,999",
    discount: "36% OFF"
  },
  {
    id: "bs_p2",
    name: "CP PLUS CP-Z32G PAN/Tilt Wi-Fi CCTV camera",
    brand: "CP PLUS",
    image: "https://cdn.moglix.com/assets/img/home_card.webp",
    rating: 5.0,
    reviewsCount: 5,
    price: "₹5,700",
    oldPrice: "₹8,999",
    discount: "36% OFF"
  },
  {
    id: "bs_p3",
    name: "CP PLUS 4MP Quad HD Wi-Fi CCTV Camera for Outdoor",
    brand: "CP PLUS",
    image: "https://cdn.moglix.com/assets/img/home_card.webp",
    rating: 5.0,
    reviewsCount: 5,
    price: "₹3,700",
    oldPrice: "₹5,999",
    discount: "38% OFF"
  },
  {
    id: "bs_p4",
    name: "CP PLUS Intelligent Home PT Camera with Cloud Remote.....",
    brand: "CP PLUS",
    image: "https://cdn.moglix.com/assets/img/home_card.webp",
    rating: 5.0,
    reviewsCount: 5,
    price: "₹5,700",
    oldPrice: "₹8,999",
    discount: "36% OFF"
  },
  {
    id: "bs_p5",
    name: "CP PLUS CP-Z32G PAN/Tilt Wi-Fi CCTV camera",
    brand: "CP PLUS",
    image: "https://cdn.moglix.com/assets/img/home_card.webp",
    rating: 5.0,
    reviewsCount: 5,
    price: "₹5,700",
    oldPrice: "₹8,999",
    discount: "36% OFF"
  }
];

export const threeSubBanners = [
  {
    image: "assets/img/credlix-banner.jpg",
    link: "https://www.credlix.com/"
  },
  {
    image: "assets/img/Brand-store-banner.png",
    link: "/brands"
  },
  {
    image: "assets/img/track-order-banner.png",
    link: "/track-order"
  }
];

export const homeSecuritySection: CategoryBlock = {
  title: "Security Systems",
  link: "/security-systems",
  brands: [
    {
      name: "CP PLUS",
      logo: "https://cdn.moglix.com/cms/element/FAB_1745833068445.jpg", // placeholder brand img
      link: "/brands/cp-plus"
    },
    {
      name: "Hikvision",
      logo: "https://cdn.moglix.com/cms/element/Generated%20Image%20September%2019,%202025%20-%204_20PM_1758279064312.png",
      link: "/brands/hikvision"
    },
    {
      name: "Dahua",
      logo: "https://cdn.moglix.com/cms/element/Generated%20Image%20September%2019,%202025%20-%204_26PM_1758279410985.png",
      link: "/brands/dahua"
    },
    {
      name: "Bosch",
      logo: "https://cdn.moglix.com/assets/img/home_card.webp",
      link: "/brands/bosch"
    }
  ],
  subCategories: [
    {
      name: "CCTV Cameras",
      image: "https://cdn.moglix.com/cms/flyout/cc3aT5ft2NI6i-xlarge.png",
      bgColor: "rgb(255, 237, 203)",
      link: "/security-systems/cctv-cameras"
    },
    {
      name: "Motion Sensors",
      image: "https://cdn.moglix.com/cms/flyout/wQts5D8PG1xzm-xlarge.png",
      bgColor: "rgb(255, 237, 203)",
      link: "/security-systems/smart-wifi-cameras"
    },
    {
      name: "Smart Door Locks",
      image: "https://cdn.moglix.com/cms/flyout/SWmIJNjv2p0Io-xlarge.png",
      bgColor: "rgb(255, 237, 203)",
      link: "/security-systems/smart-door-locks"
    },
    {
      name: "Access Control",
      image: "https://cdn.moglix.com/cms/flyout/IJkqafhCLVzqZ-xlarge.png",
      bgColor: "rgb(255, 237, 203)",
      link: "/security-systems/access-control"
    },
    {
      name: "CCTV Combo Kits",
      image: "https://cdn.moglix.com/cms/flyout/IJkqafhCLVzqZ-xlarge.png",
      bgColor: "rgb(255, 237, 203)",
      link: "/security-systems/cctv-combo-kits"
    }
  ],
  products: [
    {
      id: "hs_p1",
      name: "CP PLUS CP-Z32G PAN/Tilt Wi-Fi CCTV camera",
      brand: "CP PLUS",
      image: "https://cdn.moglix.com/assets/img/home_card.webp",
      rating: 5.0,
      reviewsCount: 5,
      price: "₹5,700",
      oldPrice: "₹8,999",
      discount: "36% OFF"
    },
    {
      id: "hs_p2",
      name: "CP PLUS CP-Z32G PAN/Tilt Wi-Fi CCTV camera",
      brand: "CP PLUS",
      image: "https://cdn.moglix.com/assets/img/home_card.webp",
      rating: 5.0,
      reviewsCount: 5,
      price: "₹5,700",
      oldPrice: "₹8,999",
      discount: "36% OFF"
    },
    {
      id: "hs_p3",
      name: "CP PLUS 4MP Quad HD Wi-Fi CCTV Camera for Outdoor",
      brand: "CP PLUS",
      image: "https://cdn.moglix.com/assets/img/home_card.webp",
      rating: 5.0,
      reviewsCount: 5,
      price: "₹3,700",
      oldPrice: "₹5,999",
      discount: "38% OFF"
    },
    {
      id: "hs_p4",
      name: "CP PLUS Intelligent Home PT Camera with Cloud Remote.....",
      brand: "CP PLUS",
      image: "https://cdn.moglix.com/assets/img/home_card.webp",
      rating: 5.0,
      reviewsCount: 5,
      price: "₹5,700",
      oldPrice: "₹8,999",
      discount: "36% OFF"
    }
  ]
};

export const architectureSection: CategoryBlock = {
  title: "Lighting Solutions",
  link: "/lighting-solutions",
  brands: [
    {
      name: "Collingwood",
      logo: "https://cdn.moglix.com/cms/element/FAB_1745833068445.jpg",
      link: "/brands/collingwood"
    },
    {
      name: "Philips",
      logo: "https://cdn.moglix.com/cms/element/Generated%20Image%20September%2019,%202025%20-%204_20PM_1758279064312.png",
      link: "/brands/philips"
    }
  ],
  subCategories: [
    {
      name: "Downlights",
      image: "https://cdn.moglix.com/cms/flyout/cc3aT5ft2NI6i-xlarge.png",
      bgColor: "rgb(230, 235, 199)",
      link: "/lighting-solutions/downlights"
    },
    {
      name: "Strip Lights",
      image: "https://cdn.moglix.com/cms/flyout/wQts5D8PG1xzm-xlarge.png",
      bgColor: "rgb(230, 235, 199)",
      link: "/lighting-solutions/strip-lights"
    },
    {
      name: "Sensor Lights",
      image: "https://cdn.moglix.com/cms/flyout/SWmIJNjv2p0Io-xlarge.png",
      bgColor: "rgb(230, 235, 199)",
      link: "/lighting-solutions/sensor-lights"
    },
    {
      name: "Outdoor Lights",
      image: "https://cdn.moglix.com/cms/flyout/IJkqafhCLVzqZ-xlarge.png",
      bgColor: "rgb(230, 235, 199)",
      link: "/lighting-solutions/outdoor-lights"
    },
    {
      name: "Garden Lights",
      image: "https://cdn.moglix.com/cms/flyout/IJkqafhCLVzqZ-xlarge.png",
      bgColor: "rgb(230, 235, 199)",
      link: "/lighting-solutions/garden-lights"
    }
  ],
  products: [
    {
      id: "al_p1",
      name: "LED COB Light in easy way",
      brand: "IndustryBull",
      image: "https://cdn.moglix.com/assets/img/home_card.webp",
      rating: 5.0,
      reviewsCount: 5,
      price: "₹5,700",
      oldPrice: "₹8,999",
      discount: "36% OFF"
    },
    {
      id: "al_p2",
      name: "H2 Deco - LED lights from the UK lighting manufacturer | Collingwood Lighting",
      brand: "Collingwood",
      image: "https://cdn.moglix.com/assets/img/home_card.webp",
      rating: 5.0,
      reviewsCount: 5,
      price: "₹3,700",
      oldPrice: "₹5,999",
      discount: "38% OFF"
    },
    {
      id: "al_p3",
      name: "Chrome Fire Rated Dimmable 4000K LED Downlight Fitting IP65 | In Stock Now",
      brand: "Collingwood",
      image: "https://cdn.moglix.com/assets/img/home_card.webp",
      rating: 5.0,
      reviewsCount: 5,
      price: "₹5,700",
      oldPrice: "₹8,999",
      discount: "36% OFF"
    },
    {
      id: "al_p4",
      name: "Lighting | Indoor & Outdoor Lighting for Everday & Commercial",
      brand: "Philips",
      image: "https://cdn.moglix.com/assets/img/home_card.webp",
      rating: 5.0,
      reviewsCount: 5,
      price: "₹3,700",
      oldPrice: "₹5,999",
      discount: "38% OFF"
    }
  ]
};

export const electricalSection: CategoryBlock = {
  title: "Electricals",
  link: "/electricals",
  brands: [
    {
      name: "Havells",
      logo: "https://cdn.moglix.com/cms/element/FAB_1745833068445.jpg",
      link: "/brands/havells"
    },
    {
      name: "Finolex",
      logo: "https://cdn.moglix.com/cms/element/Generated%20Image%20September%2019,%202025%20-%204_20PM_1758279064312.png",
      link: "/brands/finolex"
    },
    {
      name: "Microtek",
      logo: "https://cdn.moglix.com/cms/element/Generated%20Image%20September%2019,%202025%20-%204_26PM_1758279410985.png",
      link: "/brands/microtek"
    }
  ],
  subCategories: [
    {
      name: "Wiring Accessories",
      image: "https://cdn.moglix.com/cms/flyout/cc3aT5ft2NI6i-xlarge.png",
      bgColor: "rgb(255, 237, 203)",
      link: "/electricals/wiring-accessories"
    },
    {
      name: "Power Supplies",
      image: "https://cdn.moglix.com/cms/flyout/wQts5D8PG1xzm-xlarge.png",
      bgColor: "rgb(255, 237, 203)",
      link: "/electricals/power-supplies"
    },
    {
      name: "Switches & Sockets",
      image: "https://cdn.moglix.com/cms/flyout/SWmIJNjv2p0Io-xlarge.png",
      bgColor: "rgb(255, 237, 203)",
      link: "/electricals/switches-sockets"
    },
    {
      name: "SMPS / Power Supplies",
      image: "https://cdn.moglix.com/cms/flyout/IJkqafhCLVzqZ-xlarge.png",
      bgColor: "rgb(255, 237, 203)",
      link: "/electricals/smps-power-supplies"
    },
    {
      name: "Electrical Components",
      image: "https://cdn.moglix.com/cms/flyout/IJkqafhCLVzqZ-xlarge.png",
      bgColor: "rgb(255, 237, 203)",
      link: "/electricals/electrical-components"
    }
  ],
  products: [
    {
      id: "el_p1",
      name: "0.5 Sqmm Havells Life Line Plus S3 HRFR Cables, 90 m, Black",
      brand: "Havells",
      image: "https://cdn.moglix.com/assets/img/home_card.webp",
      rating: 5.0,
      reviewsCount: 5,
      price: "₹5,700",
      oldPrice: "₹8,999",
      discount: "36% OFF"
    },
    {
      id: "el_p2",
      name: "Finolex Wire 4 Sq MM FR PVC Insulated Blue 90 Meters (Gold Pack)",
      brand: "Finolex",
      image: "https://cdn.moglix.com/assets/img/home_card.webp",
      rating: 5.0,
      reviewsCount: 5,
      price: "₹3,700",
      oldPrice: "₹5,999",
      discount: "38% OFF"
    },
    {
      id: "el_p3",
      name: "Microtek inverter battery 200 ah mtk2003624tt",
      brand: "Microtek",
      image: "https://cdn.moglix.com/assets/img/home_card.webp",
      rating: 5.0,
      reviewsCount: 5,
      price: "₹5,700",
      oldPrice: "₹8,999",
      discount: "36% OFF"
    },
    {
      id: "el_p4",
      name: "Electrical Switch Types Guide | Meteor Electrical",
      brand: "Meteor",
      image: "https://cdn.moglix.com/assets/img/home_card.webp",
      rating: 5.0,
      reviewsCount: 5,
      price: "₹3,700",
      oldPrice: "₹5,999",
      discount: "38% OFF"
    }
  ]
};

export const appliancesSection: CategoryBlock = {
  title: "Home Automation",
  link: "/home-automation",
  brands: [
    {
      name: "Havells",
      logo: "https://cdn.moglix.com/cms/element/FAB_1745833068445.jpg",
      link: "/brands/havells"
    },
    {
      name: "Prestige",
      logo: "https://cdn.moglix.com/cms/element/Generated%20Image%20September%2019,%202025%20-%204_20PM_1758279064312.png",
      link: "/brands/prestige"
    }
  ],
  subCategories: [
    {
      name: "Smart Lighting Automation",
      image: "https://cdn.moglix.com/cms/flyout/cc3aT5ft2NI6i-xlarge.png",
      bgColor: "rgb(230, 235, 199)",
      link: "/home-automation/smart-lighting-automation"
    },
    {
      name: "Smart Curtains",
      image: "https://cdn.moglix.com/cms/flyout/wQts5D8PG1xzm-xlarge.png",
      bgColor: "rgb(230, 235, 199)",
      link: "/home-automation/smart-curtains"
    },
    {
      name: "Smart Fans",
      image: "https://cdn.moglix.com/cms/flyout/SWmIJNjv2p0Io-xlarge.png",
      bgColor: "rgb(230, 235, 199)",
      link: "/home-automation/smart-fans"
    },
    {
      name: "Smart AC Control",
      image: "https://cdn.moglix.com/cms/flyout/IJkqafhCLVzqZ-xlarge.png",
      bgColor: "rgb(230, 235, 199)",
      link: "/home-automation/smart-ac-control"
    },
    {
      name: "Audio / Video Automation",
      image: "https://cdn.moglix.com/cms/flyout/IJkqafhCLVzqZ-xlarge.png",
      bgColor: "rgb(230, 235, 199)",
      link: "/home-automation/audio-video-automation"
    }
  ],
  products: [
    {
      id: "ap_p1",
      name: "Havells FESTIVA , 1200mm 3 Blade 5 Star Rated BLDC Ceiling Fan",
      brand: "Havells",
      image: "https://cdn.moglix.com/assets/img/home_card.webp",
      rating: 5.0,
      reviewsCount: 5,
      price: "₹5,700",
      oldPrice: "₹8,999",
      discount: "36% OFF"
    },
    {
      id: "ap_p2",
      name: "Buy HAVELLS Festiva ES 1 Star 1200mm 3 Blade High Speed Ceiling Fan (Dust Resistant, Gold Mist) Online",
      brand: "Havells",
      image: "https://cdn.moglix.com/assets/img/home_card.webp",
      rating: 5.0,
      reviewsCount: 5,
      price: "₹3,700",
      oldPrice: "₹5,999",
      discount: "38% OFF"
    },
    {
      id: "ap_p3",
      name: "Chrome Fire Rated Dimmable 4000K LED Downlight Fitting IP65 | In Stock Now",
      brand: "Collingwood",
      image: "https://cdn.moglix.com/assets/img/home_card.webp",
      rating: 5.0,
      reviewsCount: 5,
      price: "₹5,700",
      oldPrice: "₹8,999",
      discount: "36% OFF"
    },
    {
      id: "ap_p4",
      name: "Buy BOSS 1800 watt Induction Cooktop, Soft Touch Button with 7 cooking modes, Preset timer, Auto",
      brand: "BOSS",
      image: "https://cdn.moglix.com/assets/img/home_card.webp",
      rating: 5.0,
      reviewsCount: 5,
      price: "₹3,700",
      oldPrice: "₹5,999",
      discount: "38% OFF"
    },
    {
      id: "ap_p5",
      name: "Judge By Prestige 750 Watts Aura Mixer Grinder with 3 Stainless Steel Jars|",
      brand: "Prestige",
      image: "https://cdn.moglix.com/assets/img/home_card.webp",
      rating: 5.0,
      reviewsCount: 5,
      price: "₹3,700",
      oldPrice: "₹5,999",
      discount: "38% OFF"
    },
    {
      id: "ap_p6",
      name: "Greenway Ember Stove, Improved Charcoal Cooking Stove, Ideal for Household, Small Busniesses,",
      brand: "Greenway",
      image: "https://cdn.moglix.com/assets/img/home_card.webp",
      rating: 5.0,
      reviewsCount: 5,
      price: "₹3,944",
      oldPrice: "₹5,999",
      discount: "34% OFF"
    }
  ]
};
